module.exports = __webpack_public_path__ + "img/calendar-icon.264a32d1.svg";